<template>
  <div class="course-wrapper" :style="{ backgroundImage: 'url(' + data.banner + ')' }" @click="onSelectCourse">
    <span class="name">
      <span class="tag">{{data.chapterCount}}集</span>
      {{data.name}}
    </span>
    <p class="tip">{{data.shortIntro}}</p>
    <div class="user-count">{{data.readCount}}人正在学习</div>
  </div>
</template>

<script>
export default {
  name: 'Course',
  props: {
    data: Object,
  },
  methods: {
    onSelectCourse: function () {
      this.$emit('on-select-course', this.data)
    },
  }
};
</script>

<style scoped lang="scss">
.course-wrapper {
  display: inline-block;
  width: 280px;
  border: 1px solid #bbb;
  padding: 10px 10px 10px 80px;
  margin-bottom: 10px;
  background-repeat: no-repeat;
  background-size: 60px 48px;
  background-position: 10px center;
  background-color: #fff;
  cursor: pointer;
  transition: all .2s;

  &:hover {
    // background-color: #eee;
    transform: translateX(2px) translateY(-2px);
    box-shadow: 0 0 10px rgba(0, 0, 0, .5);
  }

  .name {
    font-size: 14px;
    line-height: 20px;
    color: #101010;
  }

  .tag {
    padding: 0 2px;
    font-size: 10px;
    line-height: 15px;
    color: #de0008;
    border: 1px solid #de0008;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .tip {
    margin: 0;
    padding: 0;
    font-size: 10px;
    color: rgba(0, 0, 0, .6);
  }

  .user-count {
    font-size: 10px;
    line-height: 15px;
    color: #101010;
    padding-left: 20px;
    background-image: url('../assets/avatar.png');
    background-size: 15px;
    background-repeat: no-repeat;
    background-position: left center;
  }
}
</style>
